import { render, staticRenderFns } from "./HowToWinSection.vue?vue&type=template&id=4d8d91e0&lang=pug&"
import script from "./HowToWinSection.vue?vue&type=script&lang=js&"
export * from "./HowToWinSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports